import { createI18n } from 'vue-i18n';
import locale, { resolveLocale } from '@/locale';

const FALLBACK_LOCALE = 'en';

export const i18n = createI18n({
  locale: resolveLocale(FALLBACK_LOCALE),
  fallbackLocale: FALLBACK_LOCALE,
  messages: locale.messages,
  legacy: false,
  globalInjection: true,
  // Several legal.*/about.* messages intentionally contain HTML (rendered via
  // v-html) - this is developer-authored brand copy, not user input, so the
  // XSS warning intlify prints for HTML-containing messages doesn't apply here.
  warnHtmlMessage: false,
});

export const t = i18n.global.t;

// The sections a legal page renders, in the order they are declared. A locale
// holds only the messages it translates or overrides and inherits the rest at
// lookup time, so the set is taken from the fallback locale and extended with
// anything the active locale adds. Reading the active locale on its own would
// drop every section it inherits rather than restates.
export const legalSectionKeys = (
  namespace: string,
  tag: string = i18n.global.locale.value,
): string[] => {
  const sections = (from: string): Record<string, unknown> =>
    locale.messages[from]?.legal?.[namespace]?.sections ?? {};

  return Object.keys({ ...sections(FALLBACK_LOCALE), ...sections(tag) });
};
